export default __webpack_public_path__ + "static/media/box1.cb2102df.png";